import { Slider } from '../ui/slider';

export function CalculatorSlider({ 
    label, 
    value, 
    onChange, 
    min, 
    max, 
    step = 1, 
    prefix = '', 
    suffix = '',
    testId,
    showToggle = false,
    toggleLabel = '',
    onToggle = () => {},
    contractLabels = null,
    infoText = null,
    displayValue = null,
    displayMin = null,
    displayMax = null
}) {
    const formatValue = (val) => {
        if (prefix) return `${prefix}${val.toFixed(2)}`;
        return `${val}${suffix}`;
    };

    const currentLabel = contractLabels ? contractLabels[value] : null;

    const shownValue = displayValue ? `${prefix}${displayValue}` : formatValue(value);
    const shownMin = displayMin ? `${prefix}${displayMin}` : formatValue(min);
    const shownMax = displayMax ? `${prefix}${displayMax}` : formatValue(max);

    return (
        <div className="space-y-4" data-testid={testId}>
            <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                    <label className="font-semibold text-[#3D3B00]/70 text-sm uppercase tracking-wider">
                        {label}
                    </label>
                    {showToggle && (
                        <button
                            onClick={onToggle}
                            className="text-xs px-2 py-1 rounded-full bg-[#F5ECD7] hover:bg-[#EDE3CC] text-[#3D3B00]/60 hover:text-[#3D3B00] transition-colors border border-[#3D3B00]/10"
                            data-testid={`${testId}-toggle`}
                        >
                            ↔ {toggleLabel}
                        </button>
                    )}
                </div>
                <div className="flex items-center gap-2">
                    {currentLabel && (
                        <span className="text-xs px-2 py-1 rounded-full bg-[#4CAF50]/10 text-[#4CAF50] font-medium">
                            {currentLabel}
                        </span>
                    )}
                    <span className="font-medium text-[#3D3B00] text-lg tabular-nums font-['Outfit']">
                        {shownValue}
                    </span>
                </div>
            </div>
            <div className="custom-slider">
                <Slider
                    value={[value]}
                    onValueChange={([newValue]) => onChange(newValue)}
                    min={min}
                    max={max}
                    step={step}
                    className="w-full"
                />
            </div>
            <div className="flex justify-between text-xs text-[#3D3B00]/40">
                <span>{shownMin}</span>
                {contractLabels && contractLabels[5] && (
                    <span className="text-[#4CAF50]">{contractLabels[5]}</span>
                )}
                {infoText && (
                    <span className="text-[#4CAF50] font-medium">{infoText}</span>
                )}
                <span>{shownMax}</span>
            </div>
        </div>
    );
}
